<div class="main">
  <div class="header">
    <div class="heading">
      <div class="line"></div>
      <h5>Real Feedback from Our Clients</h5>
      <div class="line"></div>
    </div>
    <h3>Success Stories That Speak for Themselves</h3>
    <p>
      Hear from certified Executive Coaches, business leaders, and industry professionals who have elevated their
      careers, built thriving coaching practices, and made a lasting impact in their fields.
    </p>
  </div>

  <div class="contant">
    <div class="cards">

      <!-- Row 1 -->
      <div class="row">
        <div class="col-md-4 col-sm-12 card">
          <div class="testimonial-card">
            <p class="quote">
              The flexible learning options allowed me to complete my certification while managing my full-time job.
            </p>
            <div class="stars">
              <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>
              <i class="fas fa-star"></i><i class="fas fa-star"></i>
            </div>
            <div class="user-info">
              <img src="../../assets/download (2).jpeg" alt="Ronald R" class="user-img" />
              <div class="user-details">
                <h4>Ronald R</h4>
                <p>Educational Consultant</p>
              </div>
              <div class="badge">NBO</div>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-12 card">
          <div class="testimonial-card">
            <p class="quote">
              The Platinum Program gave me everything I needed to launch my coaching business—expert mentorship,
              real-world coaching experience, and ICF certification!
            </p>
            <div class="stars">
              <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>
              <i class="fas fa-star"></i><i class="fas fa-star"></i>
            </div>
            <div class="user-info">
              <img src="../../assets/download (2).jpeg" alt="Ronald R" class="user-img" />
              <div class="user-details">
                <h4>Ronald R</h4>
                <p>Educational Consultant</p>
              </div>
              <div class="badge">NBO</div>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-12 card">
          <div class="testimonial-card">
            <p class="quote">
              This certification completely transformed my leadership style. I now coach my team more effectively and
              with greater impact.
            </p>
            <div class="stars">
              <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>
              <i class="fas fa-star"></i><i class="fas fa-star"></i>
            </div>
            <div class="user-info">
              <img src="../../assets/download (2).jpeg" alt="Ronald R" class="user-img" />
              <div class="user-details">
                <h4>Ronald R</h4>
                <p>Educational Consultant</p>
              </div>
              <div class="badge">NBO</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Row 2 -->
      <div class="row">
        <div class="col-md-4 col-sm-12 card">
          <div class="testimonial-card">
            <p class="quote">
              The flexibility of the program helped me balance learning with my work and family responsibilities.
            </p>
            <div class="stars">
              <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>
              <i class="fas fa-star"></i><i class="fas fa-star"></i>
            </div>
            <div class="user-info">
              <img src="../../assets/download (2).jpeg" alt="Ronald R" class="user-img" />
              <div class="user-details">
                <h4>Ronald R</h4>
                <p>Educational Consultant</p>
              </div>
              <div class="badge">NBO</div>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-12 card">
          <div class="testimonial-card">
            <p class="quote">
              I was impressed by the depth of content and real-world relevance. The training prepared me for real coaching situations.
            </p>
            <div class="stars">
              <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>
              <i class="fas fa-star"></i><i class="fas fa-star"></i>
            </div>
            <div class="user-info">
              <img src="../../assets/download (2).jpeg" alt="Ronald R" class="user-img" />
              <div class="user-details">
                <h4>Ronald R</h4>
                <p>Educational Consultant</p>
              </div>
              <div class="badge">NBO</div>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-12 card">
          <div class="testimonial-card">
            <p class="quote">
              Thanks to this program, I’ve built a successful coaching practice and gained clients across multiple industries.
            </p>
            <div class="stars">
              <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>
              <i class="fas fa-star"></i><i class="fas fa-star"></i>
            </div>
            <div class="user-info">
              <img src="../../assets/download (2).jpeg" alt="Ronald R" class="user-img" />
              <div class="user-details">
                <h4>Ronald R</h4>
                <p>Educational Consultant</p>
              </div>
              <div class="badge">NBO</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
